module.exports = __webpack_public_path__ + "img/operator-6.png";